<andor-fieldset headline="{{ 'Notifications' | translate }}">
  <div class="notifications">
    @if (notificationService.notificationsSorted().length === 0) {
      <span>{{ "There's currently nothing to do. 🎉" | translate }}</span>
    }
    @for (
      notification of notificationService.notificationsSorted();
      track notification.id;
      let last = $last
    ) {
      <andor-notification [notification]="notification"></andor-notification>
      @if (!last) {
        <div class="spacer"></div>
      }
    }
  </div>
</andor-fieldset>
